// import { t } from "@lingui/macro";
// import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
// import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
// import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
// import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
// import { useMemo, useState } from "react";
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CardMedia,
//   Chip,
//   CircularProgress,
//   Container,
//   LinearProgress,
//   Stack,
//   Tab,
//   Tabs,
//   Typography,
// } from "@mui/material";
// import { Link } from "react-router-dom";

// import { useLmsCourses } from "@/client/services/lms";

// const DEFAULT_LMS_THUMBNAIL = "/LMS.png";

// const LmsCoursesPage = () => {
//   const { data: courses = [], isLoading } = useLmsCourses();
//   const [activeTab, setActiveTab] = useState<"explore" | "my-learnings">("explore");

//   const filteredCourses = useMemo(() => {
//     if (activeTab === "my-learnings") return courses.filter((c) => Boolean(c.enrolled));
//     return courses.filter((c) => !c.enrolled);
//   }, [activeTab, courses]);

//   return (
//     <Box>
//       <Container>
//         <Stack spacing={0.5} mb={2.5}>
//           <Typography variant="h6" sx={{ fontWeight: 500, fontSize: "1.1rem" }}>
//             {t`Learning Management`}
//           </Typography>
//         </Stack>

//         <Tabs
//           value={activeTab}
//           onChange={(_, v) => setActiveTab(v)}
//           aria-label="LMS course tabs"
//           sx={{
//             mb: 2.5,
//             minHeight: 36,
//             "& .MuiTab-root": { minHeight: 36, py: 0.75, fontSize: "0.8125rem" },
//           }}
//         >
//           <Tab value="explore" label={t`Explore courses`} />
//           <Tab value="my-learnings" label={t`My learnings`} />
//         </Tabs>

//         {isLoading ? (
//           <Stack alignItems="center" py={8}>
//             <CircularProgress />
//           </Stack>
//         ) : (
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: {
//                 xs: "1fr",
//                 sm: "repeat(2, minmax(0, 1fr))",
//                 md: "repeat(3, minmax(0, 1fr))",
//               },
//               gap: 1.75,
//             }}
//           >
//             {filteredCourses.map((course) => {
//               const hasResources = course.chapters?.some(
//                 (c) => c.resourcesEnabled && (c.resources?.length ?? 0) > 0,
//               );

//               return (
//                 <Card
//                   key={course.id}
//                   sx={{
//                     borderRadius: 2.5,
//                     display: "flex",
//                     flexDirection: "column",
//                     overflow: "hidden",
//                     transition: "border-color 0.15s",
//                     "&:hover": { borderColor: "divider" },
//                   }}
//                 >
//                   {/* Thumbnail with enrolled badge overlay */}
//                   <Box sx={{ position: "relative", flexShrink: 0 }}>
//                     <CardMedia
//                       component="img"
//                       sx={{ height: 180, objectFit: "cover", display: "block" }}
//                       image={course.thumbnailUrl || DEFAULT_LMS_THUMBNAIL}
//                       alt={course.title}
//                       onError={(e) => {
//                         e.currentTarget.src = DEFAULT_LMS_THUMBNAIL;
//                       }}
//                     />
//                   </Box>

//                   {/* Card Body */}
//                   <CardContent
//                     sx={{
//                       p: 1.5,
//                       pb: "12px !important",
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: 0.75,
//                       flex: 1,
//                     }}
//                   >
//                     {/* Level + Resources chips */}
//                     <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
//                       <Chip
//                         label={course.level || t`All Levels`}
//                         size="small"
//                         variant="outlined"
//                         sx={{ fontSize: "0.6875rem", height: 20 }}
//                       />
//                       {course.enrolled ? (
//                         <Chip
//                           label={t`Enrolled`}
//                           size="small"
//                           color="success"
//                           sx={{ fontSize: "0.6875rem", height: 20 }}
//                         />
//                       ) : null}
//                       {hasResources && (
//                         <Chip
//                           icon={<FolderOutlinedIcon sx={{ fontSize: "12px !important" }} />}
//                           label={t`Resources`}
//                           size="small"
//                           color="info"
//                           variant="outlined"
//                           sx={{ fontSize: "0.6875rem", height: 20 }}
//                         />
//                       )}
//                     </Stack>

//                     {/* Title */}
//                     <Typography
//                       variant="subtitle2"
//                       sx={{
//                         fontSize: "0.875rem",
//                         fontWeight: 600,
//                         lineHeight: 1.3,
//                         mt: 1.75,
//                         display: "-webkit-box",
//                         WebkitLineClamp: 2,
//                         WebkitBoxOrient: "vertical",
//                         overflow: "hidden",
//                       }}
//                     >
//                       {course.title}
//                     </Typography>

//                     {/* Subtitle */}
//                     {(course.subtitle || course.description) && (
//                       <Typography
//                         variant="caption"
//                         color="text.secondary"
//                         sx={{
//                           lineHeight: 1.4,
//                           mb: 1.75,
//                           display: "-webkit-box",
//                           WebkitLineClamp: 1,
//                           WebkitBoxOrient: "vertical",
//                           overflow: "hidden",
//                         }}
//                       >
//                         {course.subtitle || course.description}
//                       </Typography>
//                     )}

//                     {/* Stats row */}
//                     <Stack direction="row" spacing={1.5} color="text.secondary">
//                       <Stack direction="row" spacing={0.5} alignItems="center">
//                         <SchoolOutlinedIcon sx={{ fontSize: 13 }} />
//                         <Typography variant="caption">
//                           {course.totalLessons ?? 0} {t`lessons`}
//                         </Typography>
//                       </Stack>
//                       <Stack direction="row" spacing={0.5} alignItems="center">
//                         <AccessTimeOutlinedIcon sx={{ fontSize: 13 }} />
//                         <Typography variant="caption">
//                           {course.durationInMinutes
//                             ? `${course.durationInMinutes} mins`
//                             : t`Self paced`}
//                         </Typography>
//                       </Stack>
//                     </Stack>

//                     {/* Progress bar (enrolled only) */}
//                     {course.enrolled && (
//                       <Box>
//                         <LinearProgress
//                           variant="determinate"
//                           value={course.progressPercent ?? 0}
//                           sx={{ height: 4, borderRadius: 10, mb: 0.5 }}
//                         />
//                         <Typography variant="caption" color="text.secondary">
//                           {course.progressPercent ?? 0}% {t`complete`}
//                         </Typography>
//                       </Box>
//                     )}

//                     {/* Actions — pushed to bottom */}
//                     <Stack direction="row" spacing={0.75} sx={{ mt: "auto", pt: 0.5 }}>
//                       <Button
//                         component={Link}
//                         to={`/lms/${course.id}`}
//                         variant="contained"
//                         size="small"
//                         fullWidth
//                         sx={{ fontSize: "0.75rem", py: 0.75 }}
//                       >
//                         {t`View Course`}
//                       </Button>
//                       {course.enrolled && (
//                         <Button
//                           component={Link}
//                           to={`/lms/${course.id}/player`}
//                           variant="outlined"
//                           size="small"
//                           startIcon={
//                             <PlayCircleOutlineOutlinedIcon sx={{ fontSize: "14px !important" }} />
//                           }
//                           sx={{
//                             fontSize: "0.75rem",
//                             py: 0.75,
//                             whiteSpace: "nowrap",
//                             flexShrink: 0,
//                           }}
//                         >
//                           {t`Learn`}
//                         </Button>
//                       )}
//                     </Stack>
//                   </CardContent>
//                 </Card>
//               );
//             })}
//           </Box>
//         )}

//         {/* Empty state */}
//         {!isLoading && filteredCourses.length === 0 && (
//           <Stack alignItems="center" py={8}>
//             <Typography color="text.secondary" variant="body2">
//               {activeTab === "my-learnings"
//                 ? t`No enrolled courses yet.`
//                 : t`No courses available to explore.`}
//             </Typography>
//           </Stack>
//         )}
//       </Container>
//     </Box>
//   );
// };

// export default LmsCoursesPage;


import { t } from "@lingui/macro";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import { useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  CircularProgress,
  LinearProgress,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

import { useLmsCourses } from "@/client/services/lms";

const DEFAULT_LMS_THUMBNAIL = "/LMS.png";

const LmsCoursesPage = () => {
  const { data: courses = [], isLoading } = useLmsCourses();
  const [activeTab, setActiveTab] = useState<"explore" | "my-learnings">("explore");
  const [exploreFilter, setExploreFilter] = useState<"all" | "enrolled" | "not-enrolled">("all");

  const filteredCourses = useMemo(() => {
    if (activeTab === "my-learnings") return courses.filter((c) => Boolean(c.enrolled));
    
    switch (exploreFilter) {
      case "enrolled":
        return courses.filter((c) => Boolean(c.enrolled));
      case "not-enrolled":
        return courses.filter((c) => !c.enrolled);
      default:
        return courses;
    }
  }, [activeTab, courses, exploreFilter]);

  return (
    <Box sx={{ flexGrow: 1, px: 1 }}>
      <Stack spacing={0.5} mb={2.5}>
        <Typography variant="h6" sx={{ fontWeight: 500, fontSize: "1.1rem" }}>
          {t`Learning Management`}
        </Typography>
      </Stack>

      <Tabs
        value={activeTab}
        onChange={(_, v) => setActiveTab(v)}
        aria-label="LMS course tabs"
        sx={{
          mb: 2.5,
          minHeight: 36,
          "& .MuiTab-root": { minHeight: 36, py: 0.75, fontSize: "0.8125rem" },
        }}
      >
        <Tab value="explore" label={t`Explore courses`} />
        <Tab value="my-learnings" label={t`My learnings`} />
      </Tabs>

      {activeTab === "explore" && (
        <Stack direction="row" spacing={1} mb={2} flexWrap="wrap" useFlexGap>
          <Chip
            label={t`All`}
            onClick={() => setExploreFilter("all")}
            color={exploreFilter === "all" ? "primary" : "default"}
            variant={exploreFilter === "all" ? "filled" : "outlined"}
            size="small"
          />
          <Chip
            label={t`Enrolled`}
            onClick={() => setExploreFilter("enrolled")}
            color={exploreFilter === "enrolled" ? "primary" : "default"}
            variant={exploreFilter === "enrolled" ? "filled" : "outlined"}
            size="small"
          />
          <Chip
            label={t`Not Enrolled`}
            onClick={() => setExploreFilter("not-enrolled")}
            color={exploreFilter === "not-enrolled" ? "primary" : "default"}
            variant={exploreFilter === "not-enrolled" ? "filled" : "outlined"}
            size="small"
          />
        </Stack>
      )}

        {isLoading ? (
          <Stack alignItems="center" py={8}>
            <CircularProgress />
          </Stack>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, minmax(0, 1fr))",
                md: "repeat(3, minmax(0, 1fr))",
              },
              gap: 1.75,
            }}
          >
            {filteredCourses.map((course) => {
              const hasResources = course.chapters?.some(
                (c) => c.resourcesEnabled && (c.resources?.length ?? 0) > 0,
              );

              return (
                <Card
                  key={course.id}
                  sx={{
                    borderRadius: 2.5,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    transition: "border-color 0.15s",
                    "&:hover": { borderColor: "divider" },
                  }}
                >
                  {/* Thumbnail with enrolled badge overlay */}
                  <Box sx={{ position: "relative", flexShrink: 0 }}>
                    <CardMedia
                      component="img"
                      sx={{ height: 180, objectFit: "cover", display: "block" }}
                      image={course.thumbnailUrl || DEFAULT_LMS_THUMBNAIL}
                      alt={course.title}
                      onError={(e) => {
                        e.currentTarget.src = DEFAULT_LMS_THUMBNAIL;
                      }}
                    />
                  </Box>

                  {/* Card Body */}
                  <CardContent
                    sx={{
                      p: 1.5,
                      pb: "12px !important",
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.75,
                      flex: 1,
                    }}
                  >
                    {/* Level + Resources chips */}
                    <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
                      <Chip
                        label={course.level || t`All Levels`}
                        size="small"
                        variant="outlined"
                        sx={{ fontSize: "0.6875rem", height: 20 }}
                      />
                      {course.enrolled ? (
                        <Chip
                          label={t`Enrolled`}
                          size="small"
                          color="success"
                          sx={{ fontSize: "0.6875rem", height: 20 }}
                        />
                      ) : null}
                      {hasResources && (
                        <Chip
                          icon={<FolderOutlinedIcon sx={{ fontSize: "12px !important" }} />}
                          label={t`Resources`}
                          size="small"
                          color="info"
                          variant="outlined"
                          sx={{ fontSize: "0.6875rem", height: 20 }}
                        />
                      )}
                    </Stack>

                    {/* Title */}
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 600,
                        lineHeight: 1.3,
                        mt: 1.75,
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {course.title}
                    </Typography>

                    {/* Subtitle */}
                    {(course.subtitle || course.description) && (
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          lineHeight: 1.4,
                          mb: 1.75,
                          display: "-webkit-box",
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {course.subtitle || course.description}
                      </Typography>
                    )}

                    {/* Stats row */}
                    <Stack direction="row" spacing={1.5} color="text.secondary">
                      <Stack direction="row" spacing={0.5} alignItems="center">
                        <SchoolOutlinedIcon sx={{ fontSize: 13 }} />
                        <Typography variant="caption">
                          {course.totalLessons ?? 0} {t`lessons`}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5} alignItems="center">
                        <AccessTimeOutlinedIcon sx={{ fontSize: 13 }} />
                        <Typography variant="caption">
                          {course.durationInMinutes
                            ? `${course.durationInMinutes} mins`
                            : t`Self paced`}
                        </Typography>
                      </Stack>
                    </Stack>

                    {/* Progress bar (enrolled only) */}
                    {course.enrolled && (
                      <Box>
                        <LinearProgress
                          variant="determinate"
                          value={course.progressPercent ?? 0}
                          sx={{ height: 4, borderRadius: 10, mb: 0.5 }}
                        />
                        <Typography variant="caption" color="text.secondary">
                          {course.progressPercent ?? 0}% {t`complete`}
                        </Typography>
                      </Box>
                    )}

                    {/* Actions — pushed to bottom */}
                    <Stack direction="row" spacing={0.75} sx={{ mt: "auto", pt: 0.5 }}>
                      <Button
                        component={Link}
                        to={`/lms/${course.id}`}
                        variant="contained"
                        size="small"
                        fullWidth
                        sx={{ fontSize: "0.75rem", py: 0.75 }}
                      >
                        {t`View Course`}
                      </Button>
                      {course.enrolled && (
                        <Button
                          component={Link}
                          to={`/lms/${course.id}/player`}
                          variant="outlined"
                          size="small"
                          startIcon={
                            <PlayCircleOutlineOutlinedIcon sx={{ fontSize: "14px !important" }} />
                          }
                          sx={{
                            fontSize: "0.75rem",
                            py: 0.75,
                            whiteSpace: "nowrap",
                            flexShrink: 0,
                          }}
                        >
                          {t`Learn`}
                        </Button>
                      )}
                    </Stack>
                  </CardContent>
                </Card>
              );
            })}
          </Box>
        )}

      {/* Empty state */}
      {!isLoading && filteredCourses.length === 0 && (
        <Stack alignItems="center" py={8}>
          <Typography color="text.secondary" variant="body2">
            {activeTab === "my-learnings"
              ? t`No enrolled courses yet.`
              : t`No courses available to explore.`}
          </Typography>
        </Stack>
      )}
    </Box>
  );
};

export default LmsCoursesPage;
